module.exports = __webpack_public_path__ + "lato-normal-27bd77b9162d388cb8d4c4217c7c5e2a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-normal/lato-normal.woff
// module id = 1047
// module chunks = 0